<template>
  <div class="okr">
    <div class="el-dialog-guide" @click="closeGuide" v-if="show">
      <!-- <img src="https://imgcdn.hemiao100.com/ThemePictures/%E7%9B%AE%E6%A0%87%E6%8B%86%E5%88%86-%E6%96%B0%E6%89%8B%E6%8C%87%E5%BC%95.png" alt=""> -->
    </div>
    <div class="img-guide" v-if="show">
      <el-image
        style="width:1400px"
        src="https://imgcdn.hemiao100.com/ThemePictures/20201130145123.png"
      >
      </el-image>
      <img
        @click="closeGuide"
        class="img pointer"
        src="https://imgcdn.hemiao100.com/ThemePictures/%E5%88%86%E6%97%B6%E6%AE%B5%E7%9B%AE%E6%A0%87.png"
        alt=""
      />
    </div>
    <div
      class="flex item-center okr-title bor-m"
      style="color: #999999"
      v-if="!show"
    >
      <div class="flex-1 target-name">目标：{{ details.planName }}</div>
      <div class="flex-2 text-center">
        目标时间：{{ details.planStartDate
        }}{{ details.timeType === "year" ? "年" : "" }}至{{ details.planEndDate
        }}{{ details.timeType === "year" ? "年" : "" }}
      </div>
      <div class="flex-1 target-value text-center">{{ details.planValue }}</div>
      <div class="flex-1 person-liable">负责人：{{ details.realName }}</div>
    </div>
    <div class="" v-if="!show">
      <div class="flex item-center okr-title" style="width: 50%">
        <div class="flex-1 target-name">
          子目标：{{ details.planTargetName }}
        </div>
        <div class="flex-1 target-value">{{ details.totalSplitValue }}元</div>

        <div class="person-liable">负责人：{{ details.targetRealName }}</div>
      </div>
      <div style="width: 600px" class="mt20">
        <el-steps :active="active" align-center>
          <el-step
            icon="el-icon-edit"
            :title="o.title"
            v-for="(o, index) in stepList"
            :key="index"
          >
            <div slot="icon">
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                  index + 1 < active
                    ? o.complete
                    : active === index + 1
                    ? o.doing
                    : o.disable
                "
                placement="top-start"
              >
                <div
                  class="circular flex flex-center item-center"
                  :class="{
                    'circular-active':
                      active <= stepList.length + 1 && active > index
                  }"
                >
                  <span
                    style="font-size:22px"
                    class="hmicon"
                    :class="active <= index + 1 ? o.icon : 'icon-duigou'"
                  >
                  </span>
                </div>
              </el-tooltip>
            </div>
          </el-step>
        </el-steps>
      </div>
      <div class="mt20 ml20 mb20" style="zindex: 99999">
        <ve-histogram
          ref="histogram"
          v-if="details.targetInfoModelList"
          :data="details.chartData"
          :extend="details.extend"
          :events="chartEvents"
        ></ve-histogram>
        <!-- <el-button v-else type="primary" size="small" @click="goSplit(v)"
            >去拆分</el-button
          > -->
        <div class="mb10 flex flex-center">
          <el-button type="info" size="small" @click="close">返 回</el-button>
        </div>
      </div>
    </div>

    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1300px"
    >
      <div v-if="dialogVisible">
        <div
          class="flex flex-center item-center okr-title bor-m"
          style="color: #999"
        >
          <div class="flex-1 target-name">
            目标：{{ basicInfoModel.planName }}
          </div>
          <div class="flex-1 text-center">
            目标时间：{{ basicInfoModel.planStartDate
            }}{{ basicInfoModel.timeType === "year" ? "年" : "" }}至{{
              basicInfoModel.planEndDate
            }}{{ basicInfoModel.timeType === "year" ? "年" : "" }}
          </div>
          <div class="flex-1 target-value text-center">
            ￥{{ basicInfoModel.toPrice }}
          </div>
          <div class="flex-1 person-liable text-center">
            负责人：{{ basicInfoModel.realName }}
          </div>
        </div>

        <div class="flex flex-center item-center okr-title">
          <div class="flex-1 target-name">
            子目标：{{ detailInfoModel.planTargetName }}
          </div>
          <div class="flex-1 flex item-center">
            <el-progress
              :color="customColorMethod"
              style="width: 240px"
              :show-text="false"
              :stroke-width="12"
              :percentage="detailInfoModel.percentage"
            ></el-progress>
            <span class="ml10">{{ detailInfoModel.percentage }}%</span>
          </div>
          <div class="flex-1 flex flex-center target-value">
            <span
              :class="
                detailInfoModel.detailGoalTaskValue <
                detailInfoModel.detailConfirmTaskValue
                  ? 'danger'
                  : 'success'
              "
              >￥{{ detailInfoModel.detailGoalTaskValues }}</span
            >/￥{{ detailInfoModel.detailConfirmTaskValues }}
          </div>
          <div class=" target-value">
            负责人：{{ detailInfoModel.realName }}
          </div>
        </div>
        <div class="mb20">
          <el-table
            :data="goodsList"
            style="width: 100%"
            border
            stripe
            size="small"
            :tree-props="{
              children: 'children',
              hasChildren: 'isHaveChildren'
            }"
            :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
            :max-height="300"
            lazy
            row-key="id"
            :load="loadGoods"
          >
            <el-table-column
              header-align="left"
              align="left"
              prop="relGoodsName"
              label="商品名称"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              header-align="left"
              align="center"
              prop="categoryLevel"
              label="目标销量百分比"
            >
              <template slot-scope="scope">
                <div class="flex item-center">
                  <el-progress
                    :color="customColorMethod"
                    v-if="!isNaN(scope.row.percentage)"
                    style="width: 240px"
                    :show-text="false"
                    :stroke-width="12"
                    :percentage="scope.row.percentage"
                  ></el-progress>
                  <span class="ml10">{{ scope.row.percentage }}%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="categoryLevel"
              label="当前销量/目标销量"
            >
              <template slot-scope="scope">
                <div>
                  <span
                    :class="
                      scope.row.detailGoalTaskValue <
                      scope.row.detailConfirmTaskValue
                        ? 'danger'
                        : 'success'
                    "
                    >￥{{ scope.row.detailGoalTaskValues }}</span
                  >
                  ￥/{{ scope.row.detailConfirmTaskValues }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="mb20">
          <el-table
            :data="shopList"
            style="width: 100%"
            stripe
            size="small"
            :max-height="300"
            lazy
            row-key="id"
            :load="load"
            border
            :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
            :tree-props="{
              children: 'children',
              hasChildren: 'isHaveChildren'
            }"
          >
            <el-table-column
              header-align="left"
              align="left"
              prop="shopName"
              label="门店名称（14家）"
              show-overflow-tooltip
            >
              <template slot="header" slot-scope="scope">
                门店名称({{ shopList.length }})
              </template>
            </el-table-column>
            <el-table-column
              header-align="left"
              align="center"
              prop="categoryLevel"
              label="目标销量百分比"
              width="350"
            >
              <template slot-scope="scope">
                <div class="flex item-center">
                  <el-progress
                    :color="customColorMethod"
                    v-if="!isNaN(scope.row.percentage)"
                    style="width: 240px"
                    :show-text="false"
                    :stroke-width="12"
                    :percentage="scope.row.percentage"
                  ></el-progress>
                  <span class="ml10">{{ scope.row.percentage }}%</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="categoryLevel"
              label="当前销量/目标销量"
            >
              <template slot-scope="scope">
                <div>
                  <span
                    :class="
                      scope.row.detailGoalTaskValue <
                      scope.row.detailConfirmTaskValue
                        ? 'danger'
                        : 'success'
                    "
                    >￥{{ scope.row.detailGoalTaskValues }}</span
                  >
                  /￥{{ scope.row.detailConfirmTaskValues }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="realName"
              label="负责人"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" type="primary" size="small"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { toPrice } from "@/utils/utils";
import VeHistogram from "v-charts/lib/histogram.common";
export default {
  components: { VeHistogram },
  data() {
    var self = this;
    this.chartEvents = {
      click: function(e) {
        // self.goSplitTarget(e);
      }
    };
    return {
      show: true,
      dialogVisible: false,
      title: "",
      basicInfoModel: {},
      detailInfoModel: {},
      shopList: [],
      goodsList: [],
      active: 1,
      stepList: [
        {
          title: "1.目标拆分",
          icon: "icon-chaifenmubiao",
          doing: "进入目标拆分流程",
          complete: "目标已拆分完毕",
          disable: "当前尚未开启"
        },
        {
          title: "2.确认分时段目标",
          icon: "icon-zhuzhuangtu",
          doing: "确认分时段目标",
          complete: "计划已执行结束",
          disable: "当前尚未开启"
        },
        {
          title: "3.跟踪执行",
          icon: "icon-genzongzhihang",
          doing: "进入目标跟踪流程",
          complete: "计划已执行结束",
          disable: "当前尚未开启"
        },
        {
          title: "4.结果报告",
          icon: "icon-jieguobaogao1",
          doing: "报告已生成，请查收计划分析报告",
          complete: "报告已生成完毕",
          disable: "当前尚未开启"
        }
      ],
      targetId: this.$route.query.targetId,
      details: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryDetails();
    this.getGuiderShow();
  },
  methods: {
    getGuiderShow() {
      const prams = localStorage.getItem("isShowSplitGuider");

      if (prams) {
        this.show = false;
      }
    },
    setParamsCookie() {
      localStorage.setItem(
        "isShowSplitGuider",
        JSON.stringify({ show: this.show })
      );
    },
    closeGuide() {
      this.show = false;
      this.setParamsCookie();
    },
    customColorMethod(percentage) {
      if (percentage >= 100) {
        return "#67c23a";
      }
    },
    load(tree, treeNode, resolve) {
      this.$store.dispatch("queryTargetSplitEmployeeDetail", tree).then(res => {
        if (res.code === "0" && res.result.length) {
          res.result.forEach(v => {
            v.percentage =
              Math.floor(
                (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
              ) / 100;
            v.detailGoalTaskValues = toPrice(v.detailGoalTaskValue.toFixed(2));
            v.detailConfirmTaskValues = toPrice(
              v.detailConfirmTaskValue.toFixed(2)
            );
          });
          resolve(res.result);
        } else {
          resolve([]);
        }
      });
    },
    loadGoods(tree, treeNode, resolve) {
      this.$store.dispatch("queryTargetSplitGoodsDetail", tree).then(res => {
        if (res.code === "0" && res.result.length) {
          res.result.forEach(v => {
            v.percentage =
              Math.floor(
                (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
              ) / 100;
            v.detailGoalTaskValues = toPrice(v.detailGoalTaskValue.toFixed(2));
            v.detailConfirmTaskValues = toPrice(
              v.detailConfirmTaskValue.toFixed(2)
            );
          });
          resolve(res.result);
        } else {
          resolve([]);
        }
      });
    },
    async queryDetailsList() {
      let params = {
        planId: this.details.planId,
        targetId: this.details.targetId,
        timeValue: this.row.timeValue
      };
      const { code, result } = await this.$store.dispatch(
        "queryTargetSplitDetail",
        params
      );
      if (code === "0") {
        const {
          detailInfoModelList,
          shopDetailInfoModelList,
          basicInfoModel,
          detailInfoModel
        } = result;

        detailInfoModel.percentage =
          Math.floor(
            (detailInfoModel.detailGoalTaskValue /
              detailInfoModel.detailConfirmTaskValue) *
              10000
          ) / 100;
        detailInfoModel.detailGoalTaskValues = toPrice(
          detailInfoModel.detailGoalTaskValue.toFixed(2)
        );
        detailInfoModel.detailConfirmTaskValues = toPrice(
          detailInfoModel.detailConfirmTaskValue.toFixed(2)
        );
        detailInfoModelList.forEach(v => {
          v.percentage = v.detailGoalTaskValue
            ? Math.floor(
                (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
              ) / 100
            : 0;
          v.detailGoalTaskValues = toPrice(v.detailGoalTaskValue.toFixed(2));
          v.detailConfirmTaskValues = toPrice(
            v.detailConfirmTaskValue.toFixed(2)
          );
        });
        shopDetailInfoModelList.forEach(v => {
          // v.isHaveChildren = true;
          v.percentage =
            Math.floor(
              (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
            ) / 100;
          v.detailGoalTaskValues = toPrice(v.detailGoalTaskValue.toFixed(2));
          v.detailConfirmTaskValues = toPrice(
            v.detailConfirmTaskValue.toFixed(2)
          );
        });
        basicInfoModel.toPrice = toPrice(basicInfoModel.planValue.toFixed(2));
        this.basicInfoModel = basicInfoModel;
        this.detailInfoModel = detailInfoModel;
        this.shopList = shopDetailInfoModelList;
        this.goodsList = detailInfoModelList;

        this.dialogVisible = true;
      }
    },
    close() {
      this.$router.back(-1);
      // this.$router.push({
      //   name: "OkrWorkSplit"
      // });
    },
    goSplitTarget(e) {
      if (
        this.details.targetInfoModelList[e.dataIndex].splitState === "no" &&
        this.details.targetInfoModelList[e.dataIndex].isCanSplit === "no"
      ) {
        this.$message({
          message: "该目标尚未开始",
          type: "warning"
        });
      } else {
        if (
          this.details.targetInfoModelList[e.dataIndex].splitState === "yes"
        ) {
          this.row = this.details.targetInfoModelList[e.dataIndex];
          this.title = this.row.timeValue + "详情";
          this.queryDetailsList();
        } else {
          this.$router.push({
            name: "AffirmOkrWorkSplit",
            query: {
              row: JSON.stringify(this.details.targetInfoModelList[e.dataIndex])
            }
          });
        }
      }
    },
    async queryDetails() {
      const { code, result } = await this.$store.dispatch(
        "queryOkrPlanSplitTargetInfo",
        {
          targetId: this.targetId
        }
      );
      if (code === "0") {
        result.planValue = toPrice(result.planValue.toFixed(2));
        result.totalSplitValue = toPrice(result.totalSplitValue.toFixed(2));
        if (result.targetState === "createTarget") {
          this.active = 1;
        } else if (result.targetState === "splitTarget") {
          this.active = 2;
        } else if (result.targetState === "trackingExecution") {
          this.active = 3;
        } else if (result.targetState === "resultsReports") {
          this.active = 4;
        }
        if (result.targetInfoModelList.length > 0) {
          result.chartData = {
            columns: ["时间", "目标值"],
            rows: []
          };
          result.extend = {
            // 图标顶部的标题及按钮
            legend: {
              show: false
            },
            xAxis: {
              type: "category",
              show: true,
              // 坐标轴轴线
              axisLine: {
                show: true
              },
              // 坐标轴刻度
              axisTick: {
                show: true,
                inside: true,
                length: 10
              },
              // 坐标轴每项的文字
              axisLabel: {
                showMaxLabel: true,
                showMinLabel: true,
                color: "#000",
                rotate: 0, //刻度文字旋转，防止文字过多不显示
                margin: 8, //文字离x轴的距离
                boundaryGap: true,
                // backgroundColor:'#0f0',
                formatter: v => {
                  // console.log('x--v',v)
                  if (v.length > 3) {
                    // return v.substring(0, 3) + "...";
                  }
                  return v;
                }
              }
            },
            yAxis: {
              show: false,
              offset: 0,
              // 坐标轴轴线
              axisLine: {
                show: false
              },
              // x轴对应的竖线
              splitLine: {
                show: false
              },
              // 坐标轴刻度
              axisTick: {
                show: false
              },
              boundaryGap: false,
              axisLabel: {
                color: "#3a3a3a"
              }
            },
            // 柱形区域
            grid: {
              left: 0
              // show: true
              // backgroundColor: "#FFF6F3",
              // borderColor: "#FFF6F3"
              // containLabel:false,
            },
            series: {
              barWidth: 50,
              // barMaxWidth: 100,
              // barMinWidth: "200px",
              barMinHeight: 100,
              itemStyle: {
                // opacity: 0.67,
                // borderColor: "rgba(31, 31, 31)",
                borderWidth: 1.5,
                normal: {
                  opacity: 0.9,
                  borderWidth: 1,

                  color: function(params) {
                    if (
                      result.targetInfoModelList[params.dataIndex]
                        .splitState === "yes" &&
                      result.targetInfoModelList[params.dataIndex]
                        .isCanSplit === "yes"
                    ) {
                      return "#2FC348";
                    } else if (
                      result.targetInfoModelList[params.dataIndex]
                        .splitState === "no" &&
                      result.targetInfoModelList[params.dataIndex]
                        .isCanSplit === "yes"
                    ) {
                      return "rgba(255, 0, 0, 0.6)";
                    } else {
                      return "#DDDDDD";
                    }
                    // var colorList = [
                    //   // "#FF0000",
                    //   "#2FC348",
                    //   "#DDDDDD",
                    //   "#DDDDDD",
                    //   "#DDDDDD",
                    //   "#DDDDDD"
                    // ];
                    // if (this.isSplit(params)) {
                    //   return colorList[0];
                    // } else {
                    //   return colorList[1];
                    // }
                  },
                  borderColor: function(params) {
                    console.warn("params", params);
                  }
                }
              },

              label: {
                color: "#666",
                show: true,
                position: "top",
                formatter: params => {
                  // console.log("params", params);
                  if (
                    result.targetInfoModelList[params.dataIndex].splitState ===
                      "yes" &&
                    result.targetInfoModelList[params.dataIndex].isCanSplit ===
                      "yes"
                  ) {
                    let html = [
                      "{a|已拆分}",
                      `{b|￥${toPrice(params.value)}}`
                    ].join("\n");
                    return html;
                  } else if (
                    result.targetInfoModelList[params.dataIndex].splitState ===
                      "no" &&
                    result.targetInfoModelList[params.dataIndex].isCanSplit ===
                      "yes"
                  ) {
                    let html = [
                      "{c|待拆分}",
                      `{b|￥${toPrice(params.value)}}`
                    ].join("\n");

                    return html;
                  } else {
                    let html = [
                      "{d|未开始}",
                      `{b|￥${toPrice(params.value)}}`
                    ].join("\n");

                    return html;
                  }
                },
                rich: {
                  a: {
                    color: "#fff",
                    lineHeight: 20,
                    height: 20,
                    width: 44,
                    backgroundColor: "#2FC348",
                    align: "center",
                    borderRadius: 4
                  },
                  b: {
                    color: "#222",
                    height: 20,
                    align: "center"
                  },
                  c: {
                    color: "#fff",
                    lineHeight: 20,
                    height: 20,
                    width: 44,
                    backgroundColor: "#FF0007",
                    align: "center",
                    borderRadius: 4
                  },
                  d: {
                    color: "#222",
                    lineHeight: 20,
                    height: 20,
                    width: 44,
                    backgroundColor: "#DDDDDD",
                    align: "center",
                    borderRadius: 4
                  },
                  x: {
                    fontSize: 18,
                    fontFamily: "Microsoft YaHei",
                    borderColor: "#449933",
                    borderRadius: 4
                  }
                }
              }
            }
          };

          if (result.targetInfoModelList && result.targetInfoModelList.length) {
            result.targetInfoModelList.forEach(o => {
              o.目标值 = o.splitValue;
              o.时间 = o.timeValue;
              result.chartData.rows.push(o);
            });
          }
        }

        this.details = result;
        this.$nextTick(() => {
          this.$refs.histogram.echarts._api.getZr().on("click", params => {
            let pointInPixel = [params.offsetX, params.offsetY];
            if (
              this.$refs.histogram.echarts.containPixel("grid", pointInPixel)
            ) {
              let xIndex = this.$refs.histogram.echarts.convertFromPixel(
                { seriesIndex: 0 },
                [params.offsetX, params.offsetY]
              )[0];
              let e = {
                dataIndex: xIndex
              };
              this.goSplitTarget(e);
            }
          });
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-dialog-guide {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2040;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.7);
}
.img-guide {
  position: relative;
  .img {
    position: absolute;
    width: 300px;
    height: 266px;
    top: 231px;
    left: 17px;
    z-index: 2041;
  }
}
.okr {
  background: #ffffff;
  border-left: 6px solid #e50065;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  .bor-m {
    border-bottom: 1px solid #f4f4f4;
  }
  .okr-title {
    font-weight: 600;
    padding: 0 10px;
    height: 70px;
    font-size: 17px;
    div {
      margin-right: 10px;
    }
  }
  .circular {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #dddddd;
    .hmicon {
      color: #999;
    }
  }
  .circular-active {
    background: #e50065;
    .hmicon {
      color: #fff;
    }
  }
}
</style>
